<script setup lang="ts">
import { ref } from "vue";
import { ColumnLayout, ColumnLayoutBox } from "@/shared/components";
import { StatusMessagePage } from "@/app/registration-app/shared/components";
import {
  RegistrationForm,
  UserAlreadyExistsInfo,
} from "@/app/registration-app/user/registration/components";
import { useRegisterUser } from "./useRegisterUser.composable";

// --- Double Opt-In ---
const doubleOptInInfo = ref(false);
const showDoubleOptInInfo = () => (doubleOptInInfo.value = true);

// --- Error-Handling: User Already Exists ---
const userAlreadyExists = ref(false);
const showUserAlreadyExists = () => {
  userAlreadyExists.value = true;
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

// --- Register User ---
const { isRegisteringUser, onRegisteringUser } = useRegisterUser(
  showDoubleOptInInfo,
  showUserAlreadyExists,
);
</script>

<template>
  <StatusMessagePage
    v-if="doubleOptInInfo"
    :title="$t('registration.user.doubleOptIn.title')"
  >
    <template #text>
      <p>{{ $t("registration.user.doubleOptIn.info") }}</p>
      <p>{{ $t("registration.user.doubleOptIn.info2") }}</p>
    </template>
  </StatusMessagePage>
  <ColumnLayout v-else>
    <template #column1>
      <ColumnLayoutBox>
        <div class="registration-view">
          <h1 class="registration-view--title">
            {{ $t("registration.user.new.title") }}
          </h1>
          <div class="registration-view--text">
            <p>
              {{ $t("registration.user.new.text") }}
            </p>
            <UserAlreadyExistsInfo v-if="userAlreadyExists" />
          </div>
          <RegistrationForm
            :is-loading="isRegisteringUser"
            @register="onRegisteringUser"
          />
        </div>
      </ColumnLayoutBox>
    </template>
  </ColumnLayout>
</template>

<style scoped>
@import "RegistrationView.css";
</style>
